define('app/nav/ForgotPassword',['require','glu/model','glu/itemView','glu/http','config','glu/dialog','glu/$','hbs!./ForgotPassword.hbs'],function(require) {
	'use strict';

	var Model = require('glu/model'),
		ItemView = require('glu/itemView'),
		http = require('glu/http'),
		config = require('config'),
		dialog = require('glu/dialog'),
		$ = require('glu/$');

	return ItemView.extend({

		template: require('hbs!./ForgotPassword.hbs'),

		className: 'login floaty-box',
		binding: true,

		initialize: function(options) {
			this.model = new Model();
			this.brandMode = options && options.brandMode;
		},

		onRender: function() {
			$('.application-header').remove();
		},

		events: {
			'click .btn-submit-forgot-password': 'doSubmit'
		},

		templateHelpers: {
			sessionExpired: function() {
				return true;
			}
		},

		doSubmit: function(evt) {
			evt.preventDefault();
			var self = this;
			var pageUrl = window.location.href;
			var idx = pageUrl.lastIndexOf(config.baseUrl);
			var url = pageUrl.slice(0, idx) + config.resetPasswdUrl;
			http.post(config.apiRoot + 'auth/resetpasswdemail?url=' + url, {
				username: self.getUsername()
			}).then(function() {
				dialog.alert('We just sent an email to your account. Please check your e-mail.', 'Forgot Password');
			}, function(xhr) {
				dialog.alert('There was an error sending an e-mail to your account: ' + xhr.responseJSON.errorMessage, 'Forgot Password');
			});
			return this.$el.find('#forgot-username').val('');
		},

		getUsername: function() {
			return this.$el.find('#forgot-username').val().toString().toLocaleLowerCase();
		}
	});
});

